export default [
    {
        path: '/intrastat/declaration/list',
        name: 'intrastat_declaration_list',
        component: () => import('@src/intrastat/intrastat-declaration-list'),
        meta: {
            title: 'Intrastatmeldungen',
            role: 'ROLE_INTRASTAT_DECLARATION',
        },
    },
];
